import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectEntityFormComponent } from './direct-entity-form/direct-entity-form.component';
import { DirectEntityListComponent } from './direct-entity-list/direct-entity-list.component';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { DirectEntityRoutingModule } from './direct-entity-routing.module';

@NgModule({
  declarations: [
    DirectEntityFormComponent,
    DirectEntityListComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    SharedModule,
    ReactiveFormsModule,
    DirectEntityRoutingModule
  ]
})
export class DirectEntityModule { }
